import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input } from 'reactstrap';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles(() => ({
  formLabel: {
    marginLeft: '20px',
  },
}));

const PaidPromotion = ({
  includesPaidPromotion,
  disable,
  handleChangePaidPromotion,
}) => {
  const classes = useStyles();

  return (
    <FormGroup>
      <FormControlLabel
        className={classes.formLabel}
        control={
          <Input
            disabled={disable}
            type="radio"
            name="handleChangePaidPromotion"
            value="1"
            className="mt-0"
            checked={includesPaidPromotion === true}
            onChange={handleChangePaidPromotion}
          />
        }
        label="Yes"
      />&nbsp;&nbsp;
      <FormControlLabel
        className={classes.formLabel}
        control={
          <Input
            disabled={disable}
            type="radio"
            name="handleChangePaidPromotion"
            value="0"
            className="mt-0"
            checked={includesPaidPromotion === false}
            onChange={handleChangePaidPromotion}
          />
        }
        label="No"
      />
    </FormGroup>
  );
};
PaidPromotion.propTypes = {
  includesPaidPromotion: PropTypes.bool,
  handleChangePaidPromotion: PropTypes.func,
  disable: PropTypes.bool,
};

PaidPromotion.defaultProps = {
  disable: false,
  includesPaidPromotion: null,
  handleChangePaidPromotion: () => {},
};
export default PaidPromotion;

